import Alpine from 'alpinejs';

const isTextClamped = (elm) => elm.scrollHeight > elm.clientHeight;

Alpine.data('tabs', () => ({
  current: 'place',
  init() {
    this.checkProgramItems();
  },
  checkProgramItems() {
    const items = document.querySelectorAll('.check-lineclamp');

    items.forEach((item) => {
      if (isTextClamped(item)) {
        item.nextElementSibling.classList.remove('hidden');
        item.nextElementSibling.classList.add('flex');
      }

      const showMore = item.nextElementSibling;

      if (showMore) {
        showMore.addEventListener('click', () => {
          showMore.classList.remove('flex');
          showMore.classList.add('hidden');

          item.classList.remove('line-clamp-3');
        });
      }
    });
  },
}));
